import cn from "classnames";

import { ErrorProps } from "./Error.types";

import styles from "./Error.module.scss";

const Error = ({ message, isMargin = true }: ErrorProps) =>
  message ? (
    <div className={cn(styles.error, { [styles["error-margin"]]: isMargin })}>
      {message}
    </div>
  ) : null;

export default Error;
